import React, { useState, useEffect } from 'react';
import './ExpiryPopup.css';

const ExpiryPopup = ({ user, plans, onClose, onExtend , subscriptions}) => {
  const [daysLeft, setDaysLeft] = useState(0);
  const [currentSubscription, setCurrentSubscription] = useState(null);

  useEffect(() => {
    if (user && user.validUntil) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
      
      const expiryDate = new Date(user.validUntil);
      expiryDate.setHours(0, 0, 0, 0); // Reset time to start of day
      
      const timeDiff = expiryDate.getTime() - today.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      
      console.log('Expiry calculation:', {
        today: today.toISOString(),
        expiryDate: expiryDate.toISOString(),
        timeDiff,
        daysDiff,
        validUntil: user.validUntil
      });
      
      setDaysLeft(daysDiff);
      console.log(subscriptions);
      console.log(user);
      // Find current plan details
      if (user.planId && subscriptions.length > 0) {
        let subscription = subscriptions.find(s => s._id === user.planId);
        let plan = plans.find(p => p.id == subscription.planId);
        subscription.plan = plan;
        setCurrentSubscription(subscription);
        //console.log('Current plan found:', plan);
      }
    }
  }, [user, plans]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getUrgencyClass = () => {
    if (daysLeft <= 1) return 'critical';
    if (daysLeft <= 2) return 'urgent';
    return 'warning';
  };

  const getUrgencyMessage = () => {
    if (daysLeft <= 0) return 'Plan has expired!';
    if (daysLeft === 1) return 'Plan expires tomorrow!';
    return `Plan expires in ${daysLeft} days!`;
  };

  return (
    <div className="expiry-popup-overlay" onClick={onClose}>
      <div className={`expiry-popup ${getUrgencyClass()}`} onClick={(e) => e.stopPropagation()}>
        <div className="expiry-popup-header">
          <div className="expiry-status-indicator">
            <div className={`expiry-status-dot ${getUrgencyClass()}`}></div>
            <span className="expiry-status-text">
              {daysLeft <= 0 ? 'Subsciption Expired' : daysLeft === 1 ? 'Expires Tomorrow' : `${daysLeft} Days Left`}
            </span>
          </div>
          <button className="expiry-close-btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="expiry-popup-content">
          <div style={{display:"flex", padding:"10px"}}>
            <div className="expiry-user-avatar" style={{marginRight:"20px"}}>
              <span>{user.firstName.charAt(0)}{user.lastName.charAt(0)}</span>
            </div>
            <div className="expiry-user-details">
              <h4 className="expiry-user-name">{user.firstName} {user.lastName}</h4>
              <p className="expiry-user-email">{user.email}</p>
            </div>
          </div>
          <div className="expiry-alert-section">
            <div className="expiry-alert-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12,6 12,12 16,14"></polyline>
              </svg>
            </div>
            <div className="expiry-alert-content">
              <h3 className="expiry-alert-title">Subscription Reminder</h3>
              <p className="expiry-alert-message">{getUrgencyMessage()}</p>
              <h4 className="expiry-alert-title">Expiry Date</h4>
              <p className="expiry-alert-message"> {formatDate(user.validUntil)}</p>
            </div>
          </div>

        

          {currentSubscription && <div className="expiry-user-section" >
            <div >
              <div className="expiry-info-label">Current Plan & Subscription</div>
              <div className="expiry-info-value" style={{color:"#858585!important"}}>
              <h4 className="expiry-alert-title" >{'Plan Name      : '+ currentSubscription.plan.planName}</h4>
              

              <h4 className="expiry-alert-title">{ 'Bill Frequency: '+currentSubscription.frequency}</h4>
              

              <h4 className="expiry-alert-title">{'Bill Amount     : '+currentSubscription.currency+' '+ currentSubscription.frequencyPrice}</h4>
              
              </div>
            </div>
          </div>}

          <div className="expiry-action-buttons">
           <button className="expiry-btn expiry-btn-secondary" onClick={onClose}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M12 1v6m0 6v6"></path>
                <path d="m21 12-6-6-6 6-6-6"></path>
              </svg>
              Remind Later
            </button>
            <button className="expiry-btn btn-custom-primary" onClick={onExtend}>
              Update Subscription
            </button>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpiryPopup;